export function AdvancedSEO() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Cum mă poate ajuta cartea 'Depresia, Superputerea Ta!' să gestionez depresia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cartea oferă tehnici practice, validate științific, pentru transformarea depresiei în putere. Include exerciții de mindfulness, strategii de gestionare a anxietății, și metode de dezvoltare a rezilienței emoționale."
        }
      },
      {
        "@type": "Question",
        "name": "Ce strategii pentru sănătatea mentală voi găsi în carte?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Vei descoperi tehnici de terapie cognitivă comportamentală, exerciții de respirație pentru anxietate, metode de gestionare a stresului, și strategii practice pentru îmbunătățirea stării de spirit."
        }
      },
      {
        "@type": "Question",
        "name": "Cum mă ajută cartea să înțeleg mai bine depresia și anxietatea?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cartea explică mecanismele psihologice ale depresiei și anxietății, oferind perspective bazate pe cercetări științifice și experiențe reale. Vei învăța să recunoști tiparele negative și să le transformi în oportunități de creștere."
        }
      },
      {
        "@type": "Question",
        "name": "Ce exerciții practice pentru sănătatea mentală include cartea?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cartea conține exerciții de mindfulness, tehnici de journaling terapeutic, practici de auto-compasiune, și strategii de restructurare cognitivă pentru gestionarea gândurilor negative."
        }
      }
    ]
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Depresia, Superputerea Ta!",
    "image": "https://superputere.ro/book-cover.jpg",
    "description": "Ghid practic pentru transformarea depresiei în putere personală, cu tehnici validate științific pentru gestionarea anxietății și îmbunătățirea sănătății mentale.",
    "brand": {
      "@type": "Brand",
      "name": "Black Family Empire"
    },
    "category": "Sănătate Mentală, Dezvoltare Personală, Psihologie",
    "keywords": "depresie, anxietate, sănătate mentală, dezvoltare personală, terapie, mindfulness, psihologie",
    "offers": {
      "@type": "Offer",
      "url": "https://superputere.ro",
      "priceCurrency": "RON",
      "price": "60.00",
      "priceValidUntil": "2024-12-31",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "Black Family Empire"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "10000"
    },
    "author": {
      "@type": "Person",
      "name": "Andrei Ungureanu",
      "sameAs": [
        "https://www.tiktok.com/@omulcutourette",
        "https://www.youtube.com/@omulcutourette",
        "https://www.instagram.com/omulcutourette"
      ]
    }
  };

  const bookSchema = {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "Depresia, Superputerea Ta!",
    "author": {
      "@type": "Person",
      "name": "Andrei Ungureanu"
    },
    "bookFormat": "Hardcover",
    "genre": ["Self-help", "Mental Health", "Psychology"],
    "inLanguage": "ro-RO",
    "publisher": {
      "@type": "Organization",
      "name": "Black Family Empire"
    },
    "description": "Un ghid transformațional pentru gestionarea depresiei și anxietății, oferind tehnici practice și strategii validate științific pentru îmbunătățirea sănătății mentale.",
    "keywords": "depresie, anxietate, sănătate mentală, terapie, mindfulness, dezvoltare personală, psihologie",
    "audience": {
      "@type": "Audience",
      "audienceType": "Persoane care se confruntă cu depresie și anxietate"
    }
  };

  const healthArticleSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "about": {
      "@type": "MedicalCondition",
      "name": "Depresie",
      "description": "Informații și strategii pentru gestionarea depresiei și anxietății",
      "possibleTreatment": {
        "@type": "TherapeuticProcedure",
        "name": "Tehnici de terapie cognitivă comportamentală și mindfulness"
      }
    },
    "mainContentOfPage": {
      "@type": "WebPageElement",
      "text": "Strategii practice și validate științific pentru gestionarea depresiei și transformarea ei în putere personală"
    },
    "specialty": ["Mental Health", "Psychology", "Self-help"]
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(bookSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(healthArticleSchema)}
      </script>

      {/* Advanced Meta Tags */}
      <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="bingbot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      
      {/* Enhanced Keywords and Description */}
      <meta name="keywords" content="depresie, anxietate, sănătate mentală, terapie, psihologie, dezvoltare personală, mindfulness, gestionarea stresului, stări negative, terapie cognitivă comportamentală, exerciții mindfulness, tehnici relaxare, depresie clinică, tratament depresie, ajutor depresie, carte depresie, vindecare depresie, depășire depresie" />
      <meta name="description" content="Descoperă cum să transformi depresia în putere personală cu tehnici validate științific, exerciții de mindfulness și strategii practice pentru sănătatea mentală. Carte bestseller pentru gestionarea depresiei și anxietății." />
      
      {/* Article Meta Tags */}
      <meta property="article:published_time" content="2024-03-19T08:00:00+00:00" />
      <meta property="article:modified_time" content="2024-03-19T08:00:00+00:00" />
      <meta property="article:author" content="Andrei Ungureanu" />
      <meta property="article:section" content="Sănătate Mentală" />
      <meta property="article:tag" content="depresie, anxietate, sănătate mentală, terapie, psihologie, dezvoltare personală" />
      
      {/* Book Meta Tags */}
      <meta property="book:author" content="Andrei Ungureanu" />
      <meta property="book:isbn" content="123456789" />
      <meta property="book:release_date" content="2024-03-19" />
      <meta property="book:tag" content="depresie, anxietate, sănătate mentală" />
      
      {/* Medical/Health Meta Tags */}
      <meta name="medical:specialty" content="Mental Health, Psychology" />
      <meta name="medical:condition" content="Depression, Anxiety" />
      <meta name="medical:treatment" content="Cognitive Behavioral Therapy, Mindfulness" />
      
      {/* Social Meta Tags */}
      <meta property="og:title" content="Depresia, Superputerea Ta! | Ghid Practic pentru Sănătate Mentală" />
      <meta property="og:description" content="Transformă depresia în putere personală cu tehnici validate științific și exerciții practice pentru sănătatea mentală. Bestseller în România pentru gestionarea depresiei și anxietății." />
      <meta property="og:type" content="book" />
      <meta property="og:image" content="https://superputere.ro/book-cover.jpg" />
      <meta property="og:url" content="https://superputere.ro" />
      <meta property="og:site_name" content="Depresia, Superputerea Ta!" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Depresia, Superputerea Ta! | Ghid pentru Sănătate Mentală" />
      <meta name="twitter:description" content="Transformă depresia în putere cu tehnici validate științific. Carte bestseller pentru sănătate mentală și gestionarea anxietății." />
      <meta name="twitter:image" content="https://superputere.ro/book-cover.jpg" />
      
      {/* Product Meta Tags */}
      <meta property="product:category" content="Books > Self-Help > Mental Health" />
      <meta property="product:price:amount" content="60.00" />
      <meta property="product:price:currency" content="RON" />
      <meta property="product:availability" content="in stock" />
    </>
  );
}
